import axios from "axios";
import Swal from 'sweetalert2';

const state = {
  accountList: [], 
  accountArr: [],
  accountArray: [],
  accountID: '',
  selectedAccount: null,
  selectedRep: null,
  isEditing: false
};
  
const mutations = {
  initializeStore(state){
    state.accountList = [];
    state.accountArr = [];
    state.accountArray = [];
    state.accountID = '';
    state.selectedAccount = null;
    state.selectedRep = null;
    state.isEditing = false;
  },
  SET_SELECTED_ACCOUNT(state, account) {
    state.selectedAccount = account;
    state.isEditing = true;
  },
  SET_SELECTED_REP(state, rep) {
    state.selectedRep = rep;
  },
  LIST_ACCOUNTS(state, accounts) {
    state.accountList = accounts;
  },
  ACCOUNT_ARRAY(state, accountArray){
    state.accountArray = accountArray;
  },
  SET_STATE(state, payload) {
    for (const key in payload) {
        if (payload.hasOwnProperty(key) && key in state) {
            state[key] = payload[key];
        }
    }
  },
  SET_SEARCH_FILTERS(state, search_filter){
    for(const [key, value] of Object.entries(search_filter)){
    }
  },
  RESET_SEARCH_FILTERS(state){

  }
};
  
const actions = {
  updateState({ commit }, newState) {
    commit('SET_STATE', newState);
  },
  
  async createLeadAccount({ commit,state }, formData) {
    return axios.post('api/v1/create-lead-account/', formData)
    .then((response)=>{
      return response;
    })
    .catch((error)=>{
      console.log(error.message);
      throw error;
    })
  },

  fetchLeadAccounts({ commit,state }, formData) {
    state.accountArr = [];
    axios.post(`api/v1/get-lead-accounts/`,formData)
    .then((response)=>{
      for(let i=0; i< response.data.length; i++){
        state.accountArr.push((response.data[i].account_name + " - Email: " + response.data[i].email));
      }
      commit('LIST_ACCOUNTS', response.data);
    })
    .catch((error)=>{
      console.log(error.message);
    })
    
  },
  fetchLeadAccount({ commit,state }, formData) {
    axios.post(`api/v1/get-lead-accounts/`,formData)
    .then((response)=>{
        const selectedRep = (response.data.assigned_to != null) ? (response.data.assigned_to.name  + " - Email: " + response.data.assigned_to.email)  : "";
        state.selectedAccount = response.data;
        commit('SET_SELECTED_REP',selectedRep);
        commit('SET_SELECTED_ACCOUNT',response.data);
    })
    .catch((error)=>{
      console.log(error.message);
    })
    
  },
  handleSelectedAccount({ commit, state }, option){
    state.accountArray = [];
    const selectedAccount = state.accountList.find(account => (account.account_name + " - Email: " + account.email) === option);
    if (selectedAccount) {
        state.accountID = selectedAccount.crm_account_id;
        state.accountArray = [...state.accountArray, selectedAccount];
    }
    commit('ACCOUNT_ARRAY', state.accountArray);
      
  },

  async updateLeadAccount({ commit,state }, formData) {
    return axios.put(`api/v1/update-lead-account/`,formData)
    .then((response)=>{
      return response;
    })
    .catch((error)=>{
      console.log(error.message);
      throw error;
    })  
  },

  deleteLeadAccount({ commit,state }, formData) {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you wish to delete Account?`,
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes Delete Account!',
      cancelButtonText: 'Cancel!',
      customClass: {
          confirmButton: 'swal2-confirm-custom',
          cancelButton: 'swal2-cancel-custom',
      },
      showLoaderOnConfirm: true,
    }).then((result) => {
      if (result.value) {
        axios.post(`api/v1/delete-lead-account/`,formData)
        .then((response)=>{
          if(response.data.msg == "Success"){
              Swal.fire("Poof! Account removed succesfully!", {
                icon: "success",
              }); 
          }else{
            Swal.fire({
              title: "Error Deleting Account",
              icon: "warning",
            });
          }                   
        })
        .catch((error)=>{
          console.log(error.message);
          Swal.fire({
            title: error.message,
            icon: "warning",
          });
        })
      }else{
        Swal.fire(`Account has not been deleted!`);
      }
    })
  },

};
  
const getters = {
  // users: (state) => state.users,
  // currentUser: (state) => state.currentUser,
};
  
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
  
  